import React from 'react';

import AddProductButton from '../../../../../../components/add-product-button/add-product-button';
import NeedItNow from '../../../../../../components/need-it-now/need-it-now';
import ProductListSetCardPosition from '../product-list-set-card-position/product-list-set-card-position';

import { useMyStore } from '../../../../../../shared/hooks/hooks';

import {
  getNormalizedProductType,
  getProductSetItem
} from '../../../../../../shared/utils/product/product';

import { ProductData } from '../../../../../../shared/types/graphql-types';
import { ProductItem } from '../../../../../../shared/types/product';

import './product-list-set-card-actions.scss';

interface ProductListSetCardActionsProps {
  onAddProductClick: (productItem: ProductItem) => void;
  onQuantityChange: (quantity: number, index: number) => void;
  productSet: Array<ProductData>;
  productSetQuantity: Array<number>;
  totalQuantity: number;
}

function ProductListSetCardActions(props: ProductListSetCardActionsProps) {
  const {
    productSetQuantity,
    onAddProductClick,
    onQuantityChange,
    productSet,
    totalQuantity
  } = props;

  const { myStore } = useMyStore();

  const product = productSet[0];
  const { addToCartDisabled, stock } = product || {};
  const productType = getNormalizedProductType(product);
  const showAddToCart = !addToCartDisabled;
  const showNeedItNow =
    !addToCartDisabled && stock?.availabilityMessageRank !== 1;
  const productSetItem = getProductSetItem(
    productSet,
    productSetQuantity,
    totalQuantity
  );

  return (
    <div styleName="container">
      <div styleName="positions">
        {productSet.map((product, index) => (
          <ProductListSetCardPosition
            index={index}
            key={product?.code}
            onQuantityChange={onQuantityChange}
            product={product}
            quantity={productSetQuantity[index]}
            totalQuantity={totalQuantity}
          />
        ))}
      </div>

      <div styleName="buy">
        {showAddToCart && (
          <AddProductButton
            onClick={onAddProductClick}
            productItem={productSetItem}
            styleName="add-to-btn"
          />
        )}
      </div>

      {showNeedItNow && (
        <div styleName="need-it-now">
          <NeedItNow
            phone={myStore?.address?.phone}
            productType={productType}
          />
        </div>
      )}
    </div>
  );
}

export default ProductListSetCardActions;
